import axiosInstance from './axios';

export const medicalApi = {
    forceSyncSurveyResponses: async function() {
        try {
            const response = await axiosInstance.get(`/medical/reports/sync`);
            return response.data;
        } catch (error) {
            console.error('Error syncing survey responses', error);
            throw error;
        }
    },
    getSurveyInjuryStats: async function(season) {
        try {
            const response = await axiosInstance.get(`/medical/reports/stats?season=${season}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching survey injury stats:', error);
            throw error;
        }
    },
    getSurveyStatusOverview: async function(season) {
        try {
            const response = await axiosInstance.get(`/medical/reports?season=${season}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching survey status overview:', error);
            throw error;
        }
    },
}